import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { doNothingAsync } from '../../../../../helpers/function.helpers';
import { AnnotationToolType } from '../models/annotationToolType';
import { IAnnotationType } from '../models/annotationType';
import { IAnnotationTypeOptions } from '../models/annotationTypeOptions';
import { AnnotationTypeListItem } from './AnnotationTypesListItem';

interface IProps {
  projectId: string;
  annotationTypes: IAnnotationType[];
  annotationTypesOptions: IAnnotationTypeOptions[];
  activeAnnotationTypeId?: string;
  readonly: boolean;
  showList: boolean;
  onAnnotationTypeOptionsChanged: (projectId: string, annotationTypeOption: IAnnotationTypeOptions) => void;
  onSelectedAnnotationDelete: () => Promise<void>;
  getShortcutKey: (order: number) => string | undefined;
}

export const AnnotationTypeSelected = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const selectedAnnotationType = props.annotationTypes.find((a) => a.id === props.activeAnnotationTypeId);
  if (props.showList || !selectedAnnotationType || selectedAnnotationType.selectorType !== AnnotationToolType.BRUSH) {
    return <></>;
  }

  return (
    <div
      id='annotation-selector'
      className={`annotation-types ${props.readonly ? 'annotation-tools-readonly-overlay' : ''}`}
    >
      <div className='header'>
        <FontAwesomeIcon icon='tags' /> {t('selected_annotation_header')}
      </div>
      <AnnotationTypeListItem
        key={selectedAnnotationType.id}
        onAnnotationTypeClicked={doNothingAsync}
        onAnnotationTypeOptionsChanged={props.onAnnotationTypeOptionsChanged}
        onSelectedAnnotationDelete={props.onSelectedAnnotationDelete}
        getShortcutKey={props.getShortcutKey}
        {...selectedAnnotationType}
        active={true}
        deleteSelected={true}
        readonly={false}
        options={props.annotationTypesOptions.find((o) => o.id === selectedAnnotationType.id)}
      />
    </div>
  );
});
